export default "__VITE_ASSET__BuvNUAy4__"